import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=20c2fafa&scoped=true"
import script from "./Orcamentos.vue?vue&type=script&lang=js"
export * from "./Orcamentos.vue?vue&type=script&lang=js"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=20c2fafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2fafa",
  null
  
)

export default component.exports